import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

var _this = this;

import React, { useState, useEffect, createRef, RefObject } from 'react';
import { Table, Button, Col, Row, Container } from "react-bootstrap";
import { useHistory } from 'react-router-dom';
import receiptImage from '../../images/svg/Receipt.svg';
import { StateBootstrapButton as StateButton } from '../forms/elements';
import { connect, ReactReduxContext } from 'react-redux';
import { mobilepayDuck } from "../../ducks/mobilepay";
var mobilepayOperations = mobilepayDuck.operations;

var MobilePayLanding = function MobilePayLanding(props) {
  var _urlParams$get, _urlParams$get2;

  var code1 = props.code1,
      payload = props.payload,
      code2 = props.code2,
      check = props.check,
      receipt = props.receipt,
      isLoading = props.isLoading,
      setReceiptCode = props.setReceiptCode,
      fetchCheckDetails = props.fetchCheckDetails,
      payForOrder = props.payForOrder,
      setPayOrderPayload = props.setPayOrderPayload,
      gratuity = props.gratuity,
      setGratuity = props.setGratuity,
      showMobilePayWPError = props.showMobilePayWPError,
      setIsLoading = props.setIsLoading,
      orderId = props.orderId;
  var history = useHistory();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isError = _useState2[0],
      setError = _useState2[1]; // console.log('MobilePayLanding',props)


  if (receipt) {
    history.push("/mobilepay/success"); //     return <MobilePaySuccess payload={payload} setGratuity={setGratuity} setPayOrderPayload={setPayOrderPayload} code1={code1} code2={code2} setIsLoading={setIsLoading}
    //     check={check} receipt={receipt} gratuity={gratuity} showMobilePayWPError={showMobilePayWPError}
    //    isLoading={isLoading} setReceiptCode={setReceiptCode} fetchCheckDetails={fetchCheckDetails} payForOrder={payForOrder} />
  } // return <MobilePayCheckout payload={payload} setGratuity={setGratuity} setPayOrderPayload={setPayOrderPayload} code1={code1} code2={code2} setIsLoading={setIsLoading}
  //  check={check} receipt={receipt} gratuity={gratuity} showMobilePayWPError={showMobilePayWPError}
  // isLoading={isLoading} setReceiptCode={setReceiptCode} fetchCheckDetails={fetchCheckDetails} payForOrder={payForOrder} />


  var urlParams = new URLSearchParams(location.search);
  var overrideCodeExist = urlParams.has("code") && urlParams.has("store");
  var queryStringCode1 = (_urlParams$get = urlParams.get("store")) === null || _urlParams$get === void 0 ? void 0 : _urlParams$get.replace(/\D+/g, "");
  var queryStringCode2 = (_urlParams$get2 = urlParams.get("code")) === null || _urlParams$get2 === void 0 ? void 0 : _urlParams$get2.toLowerCase();
  if (check && !overrideCodeExist) window.location.href = "/mobilepay/checkout";

  if (overrideCodeExist && queryStringCode1 == code1 && queryStringCode2 == code2 && check) {
    window.location.href = "/mobilepay/checkout";
  } // console.log(check,overrideCodeExist, queryStringCode1 == code1, queryStringCode2 == code2 , queryStringCode1,code1,queryStringCode2,code2)


  useEffect(function () {
    if (overrideCodeExist) {
      setReceiptCode(queryStringCode1, queryStringCode2);
      continuePayment();
    }
  }, []);

  var ValidateReceiptCode = function ValidateReceiptCode() {
    if (overrideCodeExist) return false;

    if (code1 && code2) {
      if (code1.length + code2.length == 9) {
        return false;
      }

      return true;
    }

    return true;
  }; // TODO :: when page is publish 
  // if(check)
  //      history.push("/mobile-pay-checkout");


  var continuePayment = function continuePayment() {
    fetchCheckDetails();
  };

  var nextComponent = createRef();

  var handleTextChange = function handleTextChange(e) {
    var _e$target, _e$target$value;

    setReceiptCode(e.target.value, code2);

    if (((_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$value = _e$target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.length) === 4) {
      var _nextComponent$curren;

      nextComponent === null || nextComponent === void 0 ? void 0 : (_nextComponent$curren = nextComponent.current) === null || _nextComponent$curren === void 0 ? void 0 : _nextComponent$curren.focus();
    }
  };

  return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("h2", {
      className: "mobilePay_title"
    }, "Mobile Pay"), /*#__PURE__*/React.createElement(Col, {
      className: "receipt_container"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("img", {
      className: "receipt_image",
      src: receiptImage
    })), /*#__PURE__*/React.createElement("p", {
      className: "barcode_text"
    }, "Enter the code below the QR code on your receipt:"), /*#__PURE__*/React.createElement(Row, {
      className: "receiptCode_inputGroup"
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      placeholder: "0000",
      name: "receiptCode1",
      value: code1,
      maxLength: "4",
      className: "receiptCode_input" + " " + (isError ? "receipt_error_input" : ""),
      onChange: handleTextChange
    }), /*#__PURE__*/React.createElement("span", {
      className: "receiptCode_separator"
    }, " - "), /*#__PURE__*/React.createElement("input", {
      ref: nextComponent,
      type: "text",
      placeholder: "00000",
      name: "receiptCode2",
      value: code2,
      maxLength: "5",
      className: "receiptCode_input" + " " + (isError ? "receipt_error_input" : ""),
      onChange: function onChange(e) {
        return setReceiptCode(code1, e.target.value);
      }
    })), isError && /*#__PURE__*/React.createElement("p", {
      className: "receipt_error_text"
    }, "We can\u2019t find a receipt with this code. Please check your code and try again."), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(StateButton, {
      loading: isLoading,
      type: "submit",
      className: "mobilepay-payment-button",
      disabled: ValidateReceiptCode() || isLoading,
      onClick: function onClick() {
        continuePayment();
      }
    }, "Continue to Payment"))));
  }.bind(_this));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isLoading: state.mobilepay.isLoading,
    check: state.mobilepay.check,
    receipt: state.mobilepay.receipt,
    code1: state.mobilepay.code1,
    code2: state.mobilepay.code2,
    payload: state.mobilepay.payload,
    gratuity: state.mobilepay.Gratuity,
    orderId: state.mobilepay.OrderId
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setReceiptCode: function setReceiptCode(code1, code2) {
      return dispatch(mobilepayOperations.setReceiptCode(code1, code2));
    },
    fetchCheckDetails: function fetchCheckDetails(autoCode1, autoCode2) {
      return dispatch(mobilepayOperations.fetchCheckDetails(autoCode1, autoCode2));
    },
    payForOrder: function payForOrder(payload) {
      return dispatch(mobilepayOperations.payForOrder(payload));
    },
    setPayOrderPayload: function setPayOrderPayload(payload) {
      return dispatch(mobilepayOperations.setPayOrderPayload(payload));
    },
    setGratuity: function setGratuity(gratuity) {
      return dispatch(mobilepayOperations.setGratuity(gratuity));
    },
    showMobilePayWPError: function showMobilePayWPError(errorNumber) {
      return dispatch(mobilepayOperations.showMobilePayWPError(errorNumber));
    },
    setIsLoading: function setIsLoading(isLoading) {
      return dispatch(mobilepayOperations.setIsLoading(isLoading));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobilePayLanding);